import { Outlet } from "react-router-dom";

const RootPublic = () => {
  return (
    <>
      <Outlet />
    </>
  );
};

export default RootPublic;
